export default {
  async getOffers() {
    try {
      let res = await axios.get('/carry-freight/offers?current');

      if (!res.data.data) {
        return [];
      }
      return res.data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async getPastOffers(page) {
    if (page === 'undefined') {
      page = 1;
    }

    let res = await axios.get(`/carry-freight/offers?past&page=${page}`);
    return res;
  },
}
